var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"bounce"}},[(_vm.visible)?_c('div',{staticClass:"l-loading"},[_c('img',{staticClass:"loading-img",attrs:{"src":require("./images/loading.gif"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.msg))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }